<template>
    <div class="de-pic-text-wrapper">
        <div class="circle" :style="`background: url(${value}) no-repeat; background-size: contain; width: ${width}px; height: ${width}px;`"></div>
        <div class="text" :style="textStyle">
            <p class="word" :style="labelStyle">{{label}}</p>
            <p class="num" :style="percentStyle">{{typeof percent=='number' ? `${percent}%` : percent}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'de-picture-text',
    props: {
        labelProp: {
            type: String
        },
        percentProp: {
            type: [String, Number]
        },
        margin: {
            type: Number
        },
        content: {
            type: Object
        },
        fontSize: {
            type: Number
        },
        width: {
            type: Number,
            default: 108
        }
    },
    watch: {
        content: {
            handler(v) {
                if (!this.labelProp && !this.percentProp && v && Object.keys(v).length) {
                    let {label, percent, value} = v;
                    // this.value = value;
                    this.label = label;
                    this.percent = percent;
                }
            },
            immediate: true
        },
        labelProp: {
            handler(v) {
                v && (this.label = v);
            },
            immediate: true
        },
        percentProp: {
            handler(v) {
                v && (this.percent = v);
            },
            immediate: true
        },
    },
    computed: {
        textStyle() {
            return Object.assign({}, {
                marginLeft: `${this.margin}px`,
            });
        },
        labelStyle() {
            return Object.assign({}, {
                fontSize: `${this.fontSize}px`,
            });
        },
        percentStyle() {
            return Object.assign({}, {
                fontSize: `${this.fontSize+10}px`,
            });
        }
    },
    data() {
        return {
            value: require('@/runtime-components/assets/images/business.png'),
            label: '',
            percent: 0
        }
    }
}
</script>

<style lang="less" scoped>
.de-pic-text-wrapper {
    padding: 10px;
    display: flex;
    .circle {
        width: 108px;
        height: 108px;
        text-align: center;
        background-size: contain;
    }
    .text {
        padding-top: 10px;
        .word {
            font-family: 'PingFangSC-Regular';
            color: rgba(255,255,255,0.75);
        }
        .num {
            font-family: 'AgencyFB-Reg';
            color: #FFF;
        }
    }
}
</style>